var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-container",on:{"click":function($event){return _vm.jumpToPage(_vm.data.id)}}},[_c('h3',[_vm._v(_vm._s(_vm.data.title))]),_c('span',[_vm._v(_vm._s(_vm._f("timeFormat")(_vm.data.updatedAt,'YYYY-MM-DD')))]),_c('div',{staticClass:"item-content"},[_vm._v(" "+_vm._s(_vm.data.subTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }